<template>
  <van-popup v-model="getPermissionDescPopupInfo.isShow" position="top" :duration="0" :close-on-click-overlay="false" :overlay-style="{ background: 'transparent' }">
    <div class="permissionDescPopupBox">
      <div class="title" v-text="getPermissionDescPopupInfo.title"></div>
      <div class="desc" v-text="getPermissionDescPopupInfo.desc"></div>
    </div>
  </van-popup>
</template>

<script>
import { Popup } from 'vant'
import { mapGetters } from 'vuex'
export default {
  components: {
    'van-popup': Popup
  },
  computed: {
    ...mapGetters(['getPermissionDescPopupInfo'])
  }
}
</script>

<style lang="scss" scoped>
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.permissionDescPopupBox {
  width: 90%;
  background-color: #ffffff;
  margin: vw(30) auto;
  border-radius: vw(6);
  padding: vw(20);
  box-sizing: border-box;
  .title {
    font-size: vw(18);
    font-weight: 700;
    margin-bottom: vw(10);
  }
}

.van-popup {
  background-color: transparent;
}
</style>
